<template>
  <div>
    <h1 class="display-4 font-weight-lighter">
      Instructional Videos
    </h1>

    <br />

    <c-row>
      <c-col col="4" class="mb-4" v-for="link in links">
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe
                  :src="link"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          ></iframe>
        </div>
      </c-col>
    </c-row>
  </div>
</template>

<script>

export default {
  name: 'Demonstrations',
  data() {
    return {
      links: [
        'https://www.loom.com/embed/889c7215b8e940009d6ae7166d20cc34',
        'https://www.loom.com/embed/106f2fa8ae4146ab88a05d9010848c38',
        'https://www.loom.com/embed/cf9a6b7f5db84153bbdf62ac8e18cdaf',
        'https://www.loom.com/embed/f43b14c5af544ed585972c7f2eb9b88d',
        'https://www.loom.com/embed/e5a745793e484efba0e6f38525de242d'
      ],
    };
  }
}
</script>
